var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSoundcloud = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1174_32743)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM11.4241 15.381H17.6611C18.9529 15.381 20 14.2553 20 12.8667C20 11.4781 18.9529 10.3524 17.6611 10.3524C17.3876 10.3524 17.125 10.4029 16.8809 10.4957C16.8481 8.55904 15.3775 7 13.5681 7C12.7505 7 12.002 7.31837 11.4241 7.84607V15.381ZM10.0952 8.52381H10.8571V15.381H10.0952V8.52381ZM8.57143 9.28572H9.33334V15.381H8.57143V9.28572ZM7.04762 10.8095H7.80953V15.381H7.04762V10.8095ZM5.52381 10.0476H6.28572V15.381H5.52381V10.0476ZM4 11.5714H4.76191V15.381H4V11.5714Z",
  fill: "currentColor"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1174_32743"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "currentColor"
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSoundcloud, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/soundcloud.c111ce24.svg";
export { ForwardRef as ReactComponent };